import type { ReactNode } from "react";
import { usePermissions } from "@/features/account/useCurrentUser";
import { NotFoundPage } from "@/features/errors/NotFoundPage";

/**
 * Renders children only for platform admins. Non-admins get the same 404 as
 * an unknown route, so admin URLs don't reveal themselves. UI-only: the
 * backend enforces admin access on every admin endpoint regardless.
 */
export function RequirePlatformAdmin({ children }: Readonly<{ children: ReactNode }>) {
  const { isPlatformAdmin } = usePermissions();
  return isPlatformAdmin ? children : <NotFoundPage />;
}
